import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import * as InviteActions from '../actions/invite.actions';

export const featureKey = 'invites';

/**
 * @ngrx/entity provides a predefined interface for handling
 * a structured dictionary of records. This interface
 * includes an array of ids, and a dictionary of the provided
 * model type by id. This interface is extended to include
 * any additional interface properties.
 */
export interface State extends EntityState<any> {
  loading: boolean;
  error: string;
  inviteMember: any;
}

/**
 * createEntityAdapter creates an object of many helper
 * functions for single or multiple operations
 * against the dictionary of records. The configuration
 * object takes a record id selector function and
 * a sortComparer option which is set to a compare
 * function if the records are to be sorted.
 */
export const adapter: EntityAdapter<any> = createEntityAdapter<any>({
  selectId: (invite: any) => invite.id,
  sortComparer: false,
});

/**
 * getInitialState returns the default initial state
 * for the generated entity state. Initial state
 * additional properties can also be defined.
 */
export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
  inviteMember: null,
});

export const reducer = createReducer(
  initialState,
  on(InviteActions.retrieve, InviteActions.create, (state) => ({...state, loading: true})),
  on(InviteActions.retrieveSuccess, (state, {invites}) => adapter.setAll(invites, state)),
  on(InviteActions.retrieveSuccess, (state, {invites, inviteMember}) => ({
    ...state, inviteMember, loading: false, error: null
  })),
  on(InviteActions.retrieveFailure, (state, {error}) => ({...state, error}))
);
